const initialState = {
  gatewayFormsDetailsData: null,
};

/* ACTIONS */
const GATEWAY_FORMS_DETAILS_DATA = "app/gateways/GATEWAY_FORMS_DETAILS_DATA";
const CLEAR_GATEWAY_FORMS_DATA = "app/gateways/CLEAR_GATEWAY_FORMS_DATA";

type Action =
  | {
      type: typeof GATEWAY_FORMS_DETAILS_DATA;
      payload: any;
    }
  | {
      type: typeof CLEAR_GATEWAY_FORMS_DATA;
    };

/* REDUCER */
export default function reducer(state = initialState, action: any) {
  switch (action.type) {
    case GATEWAY_FORMS_DETAILS_DATA:
      return {
        ...state,
        gatewayFormsDetailsData: action.payload,
      };

    case CLEAR_GATEWAY_FORMS_DATA:
      return {
        ...state,
        gatewayFormsDetailsData: null,
      };

    default:
      return state;
  }
}

/* ACTION CREATORS */

export const setGatewayFormsDetailsData = (payload: any): Action => ({
  type: GATEWAY_FORMS_DETAILS_DATA,
  payload: payload,
});

export const clearGatewayFormsDetailsData = (): Action => ({
  type: CLEAR_GATEWAY_FORMS_DATA,
});

/* SELECTORS */
export const selectGatewayFormsDetailsData = (app: any) =>
  app.gateways.gatewayFormsDetailsData;
